export const NoAccessPage = () => {
	return (
		<div className="flex items-center justify-center h-full">
			<div className="text-center space-y-2">
				<h1 className="text-2xl font-bold text-foreground">No Access</h1>
				<p className="text-muted-foreground">
					Your role does not have access to any pages yet.
				</p>
			</div>
		</div>
	);
};
